import React, { useState } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

function getHeaders() {
  const userId = localStorage.getItem('userId');
  return userId ? { 'X-User-Id': userId } : {};
}

export default function PromoCodeRedeem({ onSuccess }) {
  const [open, setOpen] = useState(false);
  const [code, setCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);

  const handleRedeem = async (e) => {
    e?.preventDefault?.();
    if (!code.trim() || loading) return;
    setLoading(true);
    setResult(null);
    try {
      const res = await axios.post(
        `${BACKEND_URL}/api/promo-codes/redeem`,
        { code: code.trim().toUpperCase() },
        { withCredentials: true, headers: getHeaders() }
      );
      setResult({ type: 'success', message: res.data.message, days: res.data.free_days });
      setCode('');
      if (onSuccess) setTimeout(() => onSuccess(res.data), 1200);
    } catch (err) {
      setResult({
        type: 'error',
        message: err.response?.data?.detail || 'تعذّر تفعيل الكود. حاول مجدداً.'
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      data-testid="promo-code-redeem"
      className="card"
      style={{
        maxWidth: '600px',
        margin: '0 auto 32px',
        background: 'linear-gradient(135deg, rgba(255, 215, 0, 0.08), rgba(255, 165, 0, 0.05))',
        border: '2px dashed rgba(255, 165, 0, 0.4)',
      }}
    >
      {!open ? (
        <button
          data-testid="open-promo-btn"
          onClick={() => setOpen(true)}
          style={{
            width: '100%',
            background: 'transparent',
            border: 'none',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '10px',
            padding: '6px',
            fontSize: '15px',
            fontWeight: 700,
            color: '#B45309',
          }}
        >
          <span style={{ fontSize: '22px' }}>🎁</span>
          لديك كود خصم أو كود اشتراك مجاني؟ اضغط هنا
        </button>
      ) : (
        <form onSubmit={handleRedeem}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '14px' }}>
            <span style={{ fontSize: '24px' }}>🎁</span>
            <h3 style={{ margin: 0, fontSize: '17px', color: 'var(--text-dark)' }}>
              تفعيل كود الاشتراك المجاني
            </h3>
          </div>
          <p style={{ fontSize: '13px', color: 'var(--text-light)', marginBottom: '14px' }}>
            أدخل الكود الذي حصلت عليه لتفعيل أيام Premium مجاناً
          </p>
          <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
            <input
              data-testid="promo-code-input"
              type="text"
              value={code}
              onChange={(e) => setCode(e.target.value.toUpperCase())}
              placeholder="WIDAD30"
              disabled={loading}
              style={{
                flex: 1,
                minWidth: '180px',
                padding: '12px 14px',
                borderRadius: '10px',
                border: '2px solid rgba(180, 83, 9, 0.3)',
                fontSize: '17px',
                fontWeight: 700,
                letterSpacing: '2px',
                textAlign: 'center',
                textTransform: 'uppercase',
                fontFamily: 'monospace, Tajawal',
                background: 'var(--input-bg, white)',
                color: 'var(--text-dark)',
              }}
            />
            <button
              data-testid="redeem-promo-btn"
              type="submit"
              disabled={loading || !code.trim()}
              style={{
                padding: '12px 22px',
                background: 'linear-gradient(135deg, #F59E0B, #D97706)',
                color: 'white',
                border: 'none',
                borderRadius: '10px',
                fontSize: '15px',
                fontWeight: 700,
                cursor: loading || !code.trim() ? 'not-allowed' : 'pointer',
                opacity: loading || !code.trim() ? 0.6 : 1,
                boxShadow: '0 4px 12px rgba(245, 158, 11, 0.3)',
              }}
            >
              {loading ? '⏳ جاري التفعيل...' : '✨ تفعيل'}
            </button>
          </div>
          {result && (
            <div
              data-testid={result.type === 'success' ? 'promo-success' : 'promo-error'}
              style={{
                marginTop: '14px',
                padding: '12px 14px',
                borderRadius: '10px',
                background: result.type === 'success'
                  ? 'linear-gradient(135deg, rgba(16, 185, 129, 0.15), rgba(5, 150, 105, 0.10))'
                  : 'rgba(239, 68, 68, 0.12)',
                border: `1px solid ${result.type === 'success' ? 'rgba(16, 185, 129, 0.4)' : 'rgba(239, 68, 68, 0.3)'}`,
                color: result.type === 'success' ? '#059669' : '#DC2626',
                fontSize: '14px',
                fontWeight: 600,
                textAlign: 'center',
              }}
            >
              {result.message}
            </div>
          )}
          <button
            type="button"
            onClick={() => { setOpen(false); setResult(null); setCode(''); }}
            style={{
              marginTop: '10px',
              width: '100%',
              background: 'transparent',
              border: 'none',
              color: 'var(--text-light)',
              fontSize: '12px',
              cursor: 'pointer',
            }}
          >
            إلغاء
          </button>
        </form>
      )}
    </div>
  );
}
